import { useFormContext, useController } from "react-hook-form";
import React, { useState } from "react";
import { IoStar } from "react-icons/io5";

interface PaziaRatingStarsProps extends Omit<RatingStarsProps, "onSelect"> {
  onSelect?: (rating: number) => void;
  name: string;
}

export const PaziaRatingStars = ({
  onSelect,
  name,
  ...rest
}: PaziaRatingStarsProps): JSX.Element => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (rating: number) => {
    field.onChange(rating);
    if (onSelect) onSelect(rating);
  };

  return <RatingStars onSelect={onChangeHandler} {...rest} />;
};

interface RatingStarsProps {
  lowerLabel: string;
  upperLabel: string;
  onSelect: (rating: number) => void;
}
export const RatingStars = ({
  lowerLabel,
  upperLabel,
  onSelect,
}: RatingStarsProps) => {
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);
  const [selectedRating, setSelectedRating] = useState<number | null>(null);

  const handleMouseEnter = (rating: number) => setHoveredRating(rating);
  const handleMouseLeave = () => setHoveredRating(null);
  const handleClick = (rating: number) => {
    setSelectedRating(rating);
    onSelect(rating);
  };

  const renderStars = () => {
    return [1, 2, 3, 4, 5].map((rating) => (
      <IoStar
        key={rating}
        size={36}
        onMouseEnter={() => handleMouseEnter(rating)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(rating)}
        className={`cursor-pointer ${
          rating <= (hoveredRating || selectedRating || 0)
            ? "text-amber-400"
            : "text-slate-400"
        }`}
      />
    ));
  };

  return (
    <div className="w-1/2">
      <div className="flex justify-between mb-2">{renderStars()}</div>
      <div className="text-xs flex justify-between">
        <span>{lowerLabel}</span>
        <span>{upperLabel}</span>
      </div>
    </div>
  );
};
